export default "__VITE_ASSET__BUI_GsuS__"